import { PERMISSIONS } from "./context/UserContext";

/**
 * Kök adreste (/) hangi sayfanın açılacağı — giriş sonrası ilk görülen ekran.
 *
 * Tercih kullanıcının Settings JSON'unda durur (backend: UserSettings.StartPage) ve YÖNETİCİ
 * kullanıcı düzenleme formundan belirler; kullanıcı kendisi değiştiremez.
 *
 * Tercih yoksa ya da kullanıcının o sayfaya yetkisi kalmadıysa izne göre karar verilir:
 * kasa panosunu görebilen panoya, diğerleri takvime düşer. Yani rol değişince tercih
 * kullanıcıyı yetkisi olmayan bir sayfada bırakmaz.
 */
export const START_PAGES = [
    { value: '/app/appointments/calendar', labelKey: 'Calendar', permissions: [PERMISSIONS.APPOINTMENT_VIEW] },
    { value: '/app/appointments/grid', labelKey: 'Appointments', permissions: [PERMISSIONS.APPOINTMENT_VIEW] },
    { value: '/app/patients/grid', labelKey: 'Patients', permissions: [PERMISSIONS.APPOINTMENT_VIEW] },
    { value: '/app/dashboard', labelKey: 'Dashboard', permissions: [PERMISSIONS.CASH_DASHBOARD, PERMISSIONS.DASHBOARD] },
    { value: '/app/cash-view', labelKey: 'Cash Register', permissions: [PERMISSIONS.CASH_REGISTER_VIEW] }
];

export const CALENDAR_START_PAGE = '/app/appointments/calendar';
export const DASHBOARD_START_PAGE = '/app/dashboard';

/**
 * İzin kontrolü — UserContext'teki hasPermission ile aynı kural, ama bağlamdaki kullanıcıya değil
 * verilen kullanıcıya bakar: açılış kararı, sunucudan YENİ gelen profille verilebilsin diye.
 */
const userHasPermission = (user, permission) =>
    (user?.role?.permissionIdList ?? []).includes(permission)
    || (user?.permissionIdList ?? []).includes(permission);

/** Kullanıcının Settings JSON'undaki açılış sayfası tercihi; yoksa null. */
export const readStartPage = (user) => {
    try {
        return JSON.parse(user?.settings || '{}')?.startPage || null;
    }
    catch {
        // Bozuk JSON tercih yok demektir; açılış ekranı bu yüzden patlamamalı.
        return null;
    }
};

/** Tercihi yetkiyle doğrular, tutmazsa izne göre varsayılana düşer. */
export const resolveStartPage = (user) => {
    const preferred = START_PAGES.find(x => x.value === readStartPage(user));

    if (preferred && preferred.permissions.some(p => userHasPermission(user, p)))
        return preferred.value;

    return userHasPermission(user, PERMISSIONS.CASH_DASHBOARD) ? DASHBOARD_START_PAGE : CALENDAR_START_PAGE;
};
